export default {
  session_classes: state => state.classes,
  session_class_by_id: ({ classes }) => id => classes.find(c => c.id === id),
  cycle_logs: state => state.cycle_logs,
  class_statuses: state => state.class_statuses,
};



// WEBPACK FOOTER //
// ./src/store/classes/getters.js